import * as React from 'react';
import {
  LoaderCircle,
  LoaderStroke,
  LoaderStrokeLeft,
  LoaderStrokeRight
} from './CircleLoader.styled';

export interface CircleLoader {
  iconSize?: number;
  iconColor?: string;
}

export const CircleLoader = (props: Readonly<CircleLoader>) => {
  const { iconSize, iconColor } = props;
  return (
    <LoaderCircle iconSize={iconSize} iconColor={iconColor}>
      <LoaderStroke iconSize={iconSize} iconColor={iconColor}>
        <LoaderStrokeLeft iconSize={iconSize} iconColor={iconColor} />
        <LoaderStrokeRight iconSize={iconSize} iconColor={iconColor} />
      </LoaderStroke>
    </LoaderCircle>
  );
};

export default CircleLoader;
